import { render } from "./PermissionsDocumentation.vue?vue&type=template&id=554fede0&scoped=true"
import script from "./PermissionsDocumentation.vue?vue&type=script&lang=js"
export * from "./PermissionsDocumentation.vue?vue&type=script&lang=js"

import "./PermissionsDocumentation.vue?vue&type=style&index=0&id=554fede0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554fede0"]])

export default __exports__